import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "project-overview-grid grid grid--xs flex flex--wrap mb-32" }
const _hoisted_2 = { class: "project-overview-grid__column grid__item a4-12 d6-6" }
const _hoisted_3 = { class: "project-overview-grid__image-card-container flex flex--column flex--gap-medium" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "project-highlight-card__image project-highlight-card__image--default"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "project-highlight-card__text" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "project-highlight-card__title" }, " Latest images "),
  /*#__PURE__*/_createElementVNode("p", { class: "project-highlight-card__action" }, " View grid ")
], -1 /* HOISTED */)
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "project-highlight-card__image project-highlight-card__image--default"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "project-highlight-card__text" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "project-highlight-card__title" }, " Latest submissions "),
  /*#__PURE__*/_createElementVNode("p", { class: "project-highlight-card__action" }, " View submissions ")
], -1 /* HOISTED */)
const _hoisted_10 = { class: "project-overview-grid__column grid__item a4-12 d6-6" }
const _hoisted_11 = { class: "project-highlight-card" }
const _hoisted_12 = { class: "project-highlight-card__text" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "project-highlight-card__title" }, " Timetable ", -1 /* HOISTED */)
const _hoisted_14 = { class: "project-details" }
const _hoisted_15 = {
  key: 0,
  class: "project-details__item"
}
const _hoisted_16 = { class: "project-details__item-header" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "project-details__item-header" }
const _hoisted_19 = { class: "project-details__item-content" }
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 0,
  class: "project-highlight-card__text"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "project-highlight-card__title" }, " Team ", -1 /* HOISTED */)
const _hoisted_23 = { class: "project-details project-details--team" }
const _hoisted_24 = { class: "project-details__item-image" }
const _hoisted_25 = { class: "project-details__item-header" }
const _hoisted_26 = { class: "project-details__item-content" }
const _hoisted_27 = { class: "project-overview-grid__column grid__item a4-12 d6-6" }
const _hoisted_28 = { class: "project-highlight-card" }
const _hoisted_29 = { class: "project-highlight-card__text" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "project-highlight-card__title" }, " Project information ", -1 /* HOISTED */)
const _hoisted_31 = { class: "project-details" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 0,
  class: "project-details__item"
}
const _hoisted_34 = { class: "project-details__item-header" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = ["href"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "project-highlight-card project-highlight-card--image",
            onClick: _cache[0] || (_cache[0] = $event => ($setup.emit( 'set-route', 'grid' )))
          }, [
            ($setup.latest_option && ( $setup.latest_option.image_large_url || $setup.latest_option.thumbnail_url ))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: $setup.latest_option.image_large_url || $setup.latest_option.thumbnail_url,
                  alt: $setup.latest_option.title,
                  class: "project-highlight-card__image"
                }, null, 8 /* PROPS */, _hoisted_4))
              : (_openBlock(), _createElementBlock("div", _hoisted_5)),
            _hoisted_6
          ]),
          _createElementVNode("button", {
            class: "project-highlight-card project-highlight-card--image",
            onClick: _cache[1] || (_cache[1] = $event => ($setup.emit( 'set-route', 'submissions' )))
          }, [
            ($setup.latest_submission_option)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: $setup.latest_submission_option.image_large_url || $setup.latest_submission_option.thumbnail_url,
                  alt: $setup.latest_submission_option.title,
                  class: "project-highlight-card__image"
                }, null, 8 /* PROPS */, _hoisted_7))
              : (_openBlock(), _createElementBlock("div", _hoisted_8)),
            _hoisted_9
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("dl", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.project_timetable, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `project-timetable-${ index }`
                }, [
                  (item.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("dt", _hoisted_16, _toDisplayString(item.label), 1 /* TEXT */),
                        _createElementVNode("dd", {
                          class: _normalizeClass(["project-details__item-content", { 'project-details__item-content--status': item.label === 'Project Status' }])
                        }, [
                          ((
											$setup.user_is_staff_admin
											&& $setup.view_mode === 'staff'
											&& item.label === 'Project Status'
											&& item.title !== 'In-Setup'
										))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "project-details__link",
                                onClick: _cache[2] || (_cache[2] = $event => ($setup.show_project_status_modal = true))
                              }, _toDisplayString(item.title), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(item.title), 1 /* TEXT */)),
                          (item.slug && item.label === 'Project Status')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                class: _normalizeClass('project-details__status project-details__status--' + $setup.getStatusColour( item.slug ))
                              }, null, 2 /* CLASS */))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.project_documentation, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `project-documentation-${ index }`,
                  class: "project-details__item"
                }, [
                  _createElementVNode("dt", _hoisted_18, _toDisplayString(item.label), 1 /* TEXT */),
                  _createElementVNode("dd", _hoisted_19, [
                    _createElementVNode("p", null, _toDisplayString(item.title), 1 /* TEXT */),
                    (item.external_link)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: item.external_link,
                          class: "project-details__external-link",
                          target: "_blank",
                          rel: "noopener",
                          "aria-label": "Open external link"
                        }, null, 8 /* PROPS */, _hoisted_20))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          ($setup.project_team && $setup.project_team.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("dl", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.project_team, (user, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `project-team-${ index }`,
                      class: _normalizeClass([{'mt-16': user.role === 'Key Client Contact' }, "project-details__item project-details__item--image"])
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode($setup["ProfilePictureComponent"], {
                          user: user,
                          size: "md"
                        }, null, 8 /* PROPS */, ["user"])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("dt", _hoisted_25, _toDisplayString(user.role), 1 /* TEXT */),
                        _createElementVNode("dd", _hoisted_26, [
                          _createElementVNode("p", null, _toDisplayString(user.fullName), 1 /* TEXT */)
                        ])
                      ])
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("dl", _hoisted_31, [
              (!$setup.project_info.find( item => item.values.length > 0 ))
                ? (_openBlock(), _createElementBlock("p", _hoisted_32, " No information available "))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.project_info, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `project-info-${ index }`
                }, [
                  (item.values.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("dt", _hoisted_34, _toDisplayString(item.label), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.values, (value) => {
                          return (_openBlock(), _createElementBlock("dd", {
                            key: item.label + '-' + value.id,
                            class: "project-details__item-content"
                          }, [
                            (item.label ==='Location')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  ($setup.user_is_staff && $setup.view_mode === 'staff' && value.filter_route)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        class: "project-details__link",
                                        to: value.filter_route
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(value.title), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(value.title), 1 /* TEXT */)),
                                  (value.external_link)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 2,
                                        href: value.external_link,
                                        class: "project-details__link",
                                        target: "_blank",
                                        rel: "noopener",
                                        "aria-label": "Open location in Google Maps"
                                      }, " Maps ", 8 /* PROPS */, _hoisted_36))
                                    : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  ($setup.user_is_staff && $setup.view_mode === 'staff' && value.filter_route)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        class: "project-details__link",
                                        to: value.filter_route
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(value.title), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(value.title), 1 /* TEXT */)),
                                  (value.external_link)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 2,
                                        href: value.external_link,
                                        class: "project-details__external-link",
                                        target: "_blank",
                                        rel: "noopener",
                                        "aria-label": "Open external link"
                                      }, null, 8 /* PROPS */, _hoisted_38))
                                    : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($setup.user_is_staff_admin && $setup.show_project_status_modal)
            ? (_openBlock(), _createBlock($setup["ProjectStatusModalComponent"], {
                key: 0,
                project: $setup.project,
                onStatusUpdated: _cache[3] || (_cache[3] = $event => (_ctx.$emit( 'refresh-project' ))),
                onCloseModal: _cache[4] || (_cache[4] = $event => ($setup.show_project_status_modal = false))
              }, null, 8 /* PROPS */, ["project"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}